import React, { PropsWithChildren } from 'react';
import {useAsync} from "react-async-hook";
// import bridgeLogo from "../../assets/images/bridge_logo.jpg";
import {config} from "../../libs/config/config";

export const ExpoLayout: React.FC = ({children,}: PropsWithChildren<any>) => {
  useAsync(
    async () => {
      document.title = config.app.expo.name;
    },
    []);

  return (
    <>
      <main>
        <div className="flex min-h-screen min-w-full">
          <div className="w-full">
          <iframe 
            id="inlineFrameExample"
            title="notice"
            scrolling="no"
            className="min-w-full min-h-full"
            src={config.expo.notice.url} />
          </div>

          <div className="w-full">
            {children}
          </div>
        </div>
      </main>
    </>
  );
};